import { defineMessages } from 'react-intl';

export default defineMessages({
    drivers: {
        id: 'ml.quoteandbind.pup.quote.exposures.drivers',
        defaultMessage: 'Drivers'
    },
    addDriver: {
        id: 'ml.quoteandbind.pup.quote.exposures.addDriver',
        defaultMessage: 'ADD DRIVER'
    },
    excludedDrivers: {
        id: 'ml.quoteandbind.pup.quote.exposures.excludedDrivers',
        defaultMessage: 'Excluded drivers'
    },
    excludedDriversSubtitle: {
        id: 'ml.quoteandbind.pup.quote.exposures.excludedDriversSubtitle',
        defaultMessage: 'These are excluded drivers living at your physical address'
    },
    addExclDriver: {
        id: 'ml.quoteandbind.pup.quote.exposures.addExclDriver',
        defaultMessage: 'ADD EXCLUDED DRIVER'
    },
    exclDriverHelpTitle: {
        id: 'ml.quoteandbind.pup.quote.exposures.exclDriverHelpTitle',
        defaultMessage: 'What does this mean?'
    },
    exclDriverHelpDesc: {
        id: 'ml.quoteandbind.pup.quote.exposures.exclDriverHelpDesc',
        defaultMessage: 'The driver will be excluded from liability coverage under this policy.'
    },
    householdMembers: {
        id: 'ml.quoteandbind.pup.quote.exposures.householdMembers',
        defaultMessage: 'Household Members'
    },
    nonDrivers: {
        id: 'ml.quoteandbind.pup.quote.exposures.nonDrivers',
        defaultMessage: 'Non Drivers'
    },
    householdMembersSubtitle: {
        id: 'ml.quoteandbind.pup.quote.exposures.householdMembersSubtitle',
        defaultMessage: 'The following people live in your household but do not drive or have other insurance'
    },
    nonDriversSubtitle: {
        id: 'ml.quoteandbind.pup.quote.exposures.nonDriversSubtitle',
        defaultMessage: 'The following people are non drivers that do not driver or have other insurance'
    },
    addHouseholdMember: {
        id: 'ml.quoteandbind.pup.quote.exposures.addHouseholdMember',
        defaultMessage: 'ADD HOUSEHOLD MEMBER'
    },
    addNonDriver: {
        id: 'ml.quoteandbind.pup.quote.exposures.addNonDriver',
        defaultMessage: 'ADD NON DRIVER'
    },
    exclDriverTitleTooltipHeader: {
        id: 'ml.quoteandbind.pup.quote.exposures.exclDriverTitleTooltipHeader',
        defaultMessage: 'How to change from excluded?'
    },
    exclDriverTitleTooltipContent: {
        id: 'ml.quoteandbind.pup.quote.exposures.exclDriverTitleTooltipContent',
        defaultMessage: 'To change to a rated driver, click on Remove and select I need to insure this driver. To change to a household member, click on Remove and select the applicable reason.'
    },
});
